import React, { Component } from 'react'
import { Icon, Modal } from '@tinper/next-ui'
import { v1 } from 'uuid'
import { loadJS, isJDiwork, getFileUrl } from '@utils'


import './style'
import { useState, useRef, useEffect } from 'react';

const Upload = (props) => {
  const {
    value,
    objectName,
    disabled,
    readOnly,
    canDownload,
    enablePersonalLimit,
    showType = '1',
    visible,
    nid,
    alias,
    controlType,
    renderEnv,
    designDomAttr,
    cStyle,
    fieldid,
    fieldidPrefix,
    uploadFileId,
    queryFileInfo, // 本地数据存储
    afterDelete, // 删除数据后回调
    isBatch, // 是不是依赖批量查询等
    listData = [],
    copyFile,
    isCopy,
    customDesText, // Boolean|String 自定义文案，默认false
    customEmptyStatus, // Boolean|String 自定义缺省图片，默认false   customEmptyStatus  = <img src='' width=''  height=''/>
    uploadBtnShowText,
    noTemporaryValue, // 是不是用临时值
    fileParams = {},
    mode,
  } = props;
  const realFieldId = fieldid || fieldidPrefix;
  const randomId = v1();
  const [currentValue, setCurrentValue] = useState(props.value);
  const [modalVisible, setModalVisible] = useState(false);
  const [filesCount, setFilesCount] = useState(listData?.length || 0);
  const [objectId, setObjectId] = useState(value);
  const [tempObjectId, setTempObjectId] = useState(randomId);
  const fileDom = useRef(null);
  const [instance, setInstance] = useState(null);
  const [noEdit, setNoEdit] = useState(disabled || readOnly || false);
  const prevProps = useRef(null); // hooks闭包，导致上传后拿到的onchange事件还是老的
  // 解析objectid等接口参数
  const formatParams = (isSearch = false, temp, type) => {
    return {
      objectId: props.value || temp || tempObjectId, // 文件id
      tempObjectId: temp || tempObjectId,
      isTemp: noTemporaryValue ? false : (value !== (temp || tempObjectId)), // 存在问题 浏览态是不是要上传附件等
      isSearch: (showType === '2' ? false : (!!props.value || isSearch)) && !isBatch, // 这个还得再处理 下次写清楚 处理啥 咋了 现在忘了吧
      listData: props.value && props.listData || [],
      updateListData: showType === '2' && !isBatch
    //   isTemp: false, // 先改bug吧
    }
  }

  // 解析按钮权限数据
  const formatAuthParams = () => {
    const { required, notRequired, enablePersonalLimit, canDownload, uploadInBrowse = false, cameraOnly = false } = props;
    const canEdit = noEdit && !uploadInBrowse;
    const authParams = {
      auth: {
        canDownload, // 是否可以下载
        canUpload: !cameraOnly && !canEdit, // 是否可以上传
        canDelete: !canEdit, // 是否可以删除
        canEdit: !canEdit, // 是否可以编辑
        enablePersonalLimit // 是否只能删自己上传的文件
      },
      isMustUpload: required ?? !notRequired
    }
    console.log('%c auth', 'color: pink;font-size:20px', authParams);
    return authParams;
  }

  // 解析一般不动的配置数据
  const formatConfigParams = () => {
    const { fileType = 7, objectName, maxCount, label, maxSize, format, authId, enablePreview, showUploader = false } = props;
    const uploadParam = {
      el: fileDom?.current,
      fileType,
      objectName, // 调用方应用 code，必须先申请 注册 后方能使用 等
      maxCount, // 最多文件上传数量限制，不传或者 0 时，则不做限制
      uploadBtnShowText: uploadBtnShowText !== undefined ? uploadBtnShowText : label, // 组件名称
      maxSize, // 单文件最大容量
      format, // 文件类型限定，如 ["jpg","png","pdf"]
      authId, // ybbase是应用构建菜单的serviceCode，在设计器状态下使用
      buttonAuthId: 'iuapfile-public', // 协同规则：原厂单据需要透传
      enablePreview,
      customDesText, // Boolean|String 自定义文案，默认false
      customEmptyStatus, // Boolean|String 自定义缺省图片，默认false   customEmptyStatus  = <img src='' width=''  height=''/>
      hideCreator: !showUploader,
      ...fileParams,
      beforeUpload: (data) => {
        return new Promise((resolve, reject) => {
          if (props.beforeUpload) {
            props?.beforeUpload(resolve)
          } else {
            resolve(true)
          }
        })
      },
      onFileUploadFailCallBack: () => {
        props?.onFileUploadFailCallBack?.();
      },
      onFileUploadCallBack: (fileJson) => {
        setTimeout(() => {
          prevProps?.current?.onFileUploadCallBack?.({
          fileJson
        })
        }, 10);
        prevProps?.current?.onChange?.(fileJson.objectId)
        // 文件上传成功回调
        console.log('文件上传成功回调------', fileJson)
        // setState({ filesCount: fileJson?.fileCounts || 0 })
        setFilesCount(fileJson?.fileCounts || 0)
      },
      onBeforeDeleteCallBack: (data) => {
        // 删除前
        return props?.onBeforeDeleteCallBack?.(data);
      },
      onFileDeleteCallBack: (fid, fileCount, fileJson) => {
        // 删除成功
        setFilesCount(fileCount);
        props?.onFileDeleteCallBack?.({ fid, fileCount, fileJson })
        // 文件删除成功回调
        if (!fileCount) {
          props?.onChange?.();
        }
        afterDelete?.(fid);
      },
      onSecurityAttachmentOperationCallBack: (file) => {
        // 密集打开前
        props?.onSecurityAttachmentOperationCallBack?.(file);
        return file;
      },
      onBeforeDownloadCallBack: (data1) => {
        // 下载前 处理下载名称等
        return props?.onBeforeDownloadCallBack?.(data1);
      },
      onBeforePreviewCallBack: (data1) => {
        // 预览前 可以处理预览地址等
        return props?.onBeforePreviewCallBack?.(data1);
      },
      onBeforeBatchDownload: (filesInformation) => {
        // 批量下载前
        const obj = {};
        props?.onBeforeBatchDownload?.(obj, filesInformation);
        return obj;
      }
    }
    return uploadParam;
  }

  // 解析渲染组件
  const parseFile = () => {
    const authParams = formatAuthParams();
    const params = formatParams();
    const configParams = formatConfigParams();
    const uploadParam = {
      ...authParams,
      ...params,
      ...configParams
    };
    // uploadFileRef为当前附件上传组件的div对象
    if (fileDom) {
      fileDom.innerHTML = '';
    }
    if (props.beforeRenderFileComponent) {
      props.beforeRenderFileComponent(uploadParam)
    }
    // 初始化流程实例
    window.YYCooperationBridge
    && window.YYCooperationBridge?.ready
    && window?.YYCooperationBridge?.YYRenderFile?.(uploadParam).then((instance) => {
      instance.objectId = uploadParam.objectId;
      setInstance(instance);
      props.afterInit?.(instance);
    }).catch(err => {
    })
  }

  // 加载附件js等资源
  const loadFileResources = (callback) => {
    if ((isJDiwork() && window.YYCooperationBridge) || window.uploadFileLoading) {
      const timer = setInterval(() => {
        // 如果js加载完毕，清除定时器，并执行init
        // console.log('%c 加载文件js')
        if (window.YYCooperationBridge?.ready) {
          clearInterval(timer);
          window.YYCooperationBridge?.ready?.(() => {
            // console.log('%c 加载文件js', 'color: #d90890')
            callback();
          });
        }
      }, 100)
    } else {
      window.uploadFileLoading = true;
      loadJS(
        getFileUrl(),
        'ybUploadFileservice',
        () => {
        //   console.log('%c 加载文件js---', 'color: #d90890')
          callback();
        },
        () => {
          let flag = false
          window.YYCooperationBridge?.ready?.(() => {
            flag = true
            window.uploadFileLoading = false
          });
          return flag
        }
      )
    }
  }
  // 复制附件
  const copy = () => {
    const temp = v1();
    const newAttachmentIdList = [{
      sourceObjectId: value,
      sourceObjectName: objectName,
      targetObjectId: temp,
      targetObjectName: objectName,
    }];
    window.YYCooperationBridge.YYFormFilesCopyAllV2({
      copyList: newAttachmentIdList,
      callback: () => {
        setTempObjectId(temp);
        props?.onChange(temp);
      },
      extraParams: {
        authId: props.authId
      }
    })
  }

  useEffect(() => {
    prevProps.current = props;
  })
  // 初始化主表附件--- start ---
  useEffect(() => {
    const domid = `#${uploadFileId}`
    if (document.querySelector(domid)?.closest('.plain-txt')) {
      document.querySelector(domid).closest('.plain-txt').style.maxHeight = "none"
    }
    // 协同js在加载中
    if (showType !== '2') {
      if (window.YYCooperationBridge?.ready) {
        window.YYCooperationBridge.ready(() => {
          parseFile();
        });
      } else {
        loadFileResources(parseFile);
      }
    }
    queryFileInfo?.({
      objectId,
      tempObjectId,
      objectName
    });
    return () => {
      instance?.close?.()
    }
  }, []);

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
      if (instance && value !== instance?.objectId) {
        const temp = v1();
        setTempObjectId(temp);
        const params = formatParams(true, temp); // 删除以后
        instance.objectId = params.objectId;
        instance.update(params);
      }
    }
  }, [value])
  // 主表监听value变化更新参数
  useEffect(() => {
    if (instance && ((!currentValue && (instance?.objectId !== tempObjectId)) || (currentValue && currentValue !== instance?.objectId))) {
      // 初始化以后value值变了 和 初始化传入的值不一样
      // 比如初始化value = 1 , 后 value = undefined , undefined !== 1 && 1 !== tempobj
        const temp = v1();
        setTempObjectId(temp);
        const params = formatParams(true, temp); // 删除以后
      // 列表页点复制进来
      if (copyFile && props.value !== tempObjectId && props.value) {
        copy();
      } else {
        instance.objectId = params.objectId;
        instance.update(params);
      }
    }
  }, [instance]);

  // 附件复制
  useEffect(() => {
    // 卡片点复制的时候
    if (isCopy && instance && !isBatch) {
      instance.update({
        isSearch: true, // 没有值的附件 编辑 取消 重新调接口有问题
      });
    }
  }, [isCopy])

  // 主表设置组件是不是要搜索、是不是临时态
  useEffect(() => {
    if (instance && !isBatch) {
      if (noEdit) {
        // console.log('文件afterInit事件更新value121212-------');
        const temp = v1();
        instance.update({
          isSearch: !isBatch, // 没有值的附件 编辑 取消 重新调接口有问题
          isTemp: false,
          tempObjectId: temp
        });
        setTempObjectId(temp);
        if (showType === '2' && !isBatch) {
          if (value) {
            batchFiles();
          } else {
            setFilesCount(0);
          }
        }
      } else {
        instance.update({
          isTemp: !noTemporaryValue,
        });
      }
    }
  }, [noEdit]);

useEffect(() => {
    if (instance && isBatch) {
      if (mode !== 'browse') {
        instance.update({
          isTemp: !noTemporaryValue,
        });
      } else {
        // 浏览态
        const temp = v1();
        instance.update({
          isSearch: false, // 没有值的附件 编辑 取消 重新调接口有问题
          isTemp: false,
          tempObjectId: temp
        });
        setTempObjectId(temp);
      }
    }
  }, [mode]);

  useEffect(() => {
    if (instance && isBatch) {
      if (mode !== 'browse') {
        instance.update({
          isTemp: !noTemporaryValue,
        });
      } else {
        // 浏览态
        const temp = v1();
        instance.update({
          isSearch: false, // 没有值的附件 编辑 取消 重新调接口有问题
          isTemp: false,
          tempObjectId: temp
        });
        setTempObjectId(temp);
      }
    }
  }, [mode]);

  useEffect(() => {
    setNoEdit(disabled || readOnly || false);
  }, [disabled, readOnly]);
  
  // 组件设置上传、删除、下载等的权限
  useEffect(() => {
    if (instance) {
      const authParams = formatAuthParams();
      instance.updateAuth({
        ...authParams
      });
    }
  }, [noEdit, canDownload, enablePersonalLimit, instance]);

  // --- 初始化子表附件start ---
  useEffect(() => {
    if (showType === '2') {
      if (value) {
        batchFiles();
      } else {
        setFilesCount(0);
      }
    }
    // console.log('%c value变了吗', 'color: red', value);
  }, [value])

  // 批量附件
  useEffect(() => {
    if (isBatch) {
      if (showType === '1') {
        instance?.update({
          isSearch: false, // 没有值的附件 编辑 取消 重新调接口有问题
          listData,
          updateListData: true
        }, false);
      }
      setFilesCount(listData?.length || 0)
    }
  }, [listData])

  // 将附件的值存在pageStore便于保存时候获取
  useEffect(() => {
    queryFileInfo?.({
      objectId: value,
      tempObjectId,
      objectName
    });
  }, [tempObjectId, value])

  const batchFiles = () => {
    loadFileResources(() => {
      props.afterComponentLoad?.();
      if (!isBatch) { // 简单模式
        window.YYCooperationBridge?.YYFormFileGetAllListByObjectIdV2({
          extraParams: {
            authId: props.authId
          },
          searchList: [{
            objectId: value,
            objectName
          }] 
        }).then((data) => {
          props?.batchFileUploadCallBack?.(`${value}_${objectName}`, data);
          setFilesCount(data?.length);
        })
      }
    //   console.log('%c value变了吗', 'color: green', value);
    })
  }

  const handleClick = () => {
    if (nid) return;
    setModalVisible(!modalVisible);
    setTimeout(() => {
      loadFileResources(parseFile)
    })
  }

  const renderFile = () => {
    let designObj = designDomAttr
    if (props.isDesigner !== true) {
      designObj = {};
    }
    let styles;
    try {
      styles = JSON.parse(cStyle)
    } catch (err) {
    }
    const hideNum = props.isBatch && noEdit && showType === '1'
    const oneNum = hideNum && listData?.length === 1;
    return (
        <div
          nid={nid} controlType={controlType}
          {...designDomAttr}
          className={`${uploadFileId} upload-component-ynf ${hideNum ? 'hide-file-num' : ''} ${oneNum ? 'one-file-num' : ''} ${props.isDesigner ? 'designer-style' : ''}`}
          style={{ ...styles }}
          id={`${uploadFileId}`}
          ref={fileDom}
          onScroll={(event) => {event.stopPropagation()}}
        ></div>
    )
  }

  const renderNumber = () => {
    let { cStyle = {} } = props
    let styles;
    try {
      styles = JSON.parse(cStyle)
    } catch (err) {
    }
    return (
      <div nid={nid} controlType={controlType} {...designDomAttr}>
        <span onClick={handleClick} className='upload-file-count'>
          <Icon fieldid={`${realFieldId}-icon`} type='uf-fujian'></Icon>
          <span>{`(${filesCount})`}</span>
        </span>
        <Modal fieldid={`${realFieldId}-modal`} show={modalVisible} maskClosable={false} onCancel={() => setModalVisible(false)} footer={null}>
          <Modal.Header fieldid={`${realFieldId}-modal-header`} closeButton closeButtonProps={{ fieldid: 'closeBtn' }}>
            <Modal.Title fieldid={`${realFieldId}-modal-title`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A2', '附件管理', undefined, {returnStr: true, placement: 'top'})}</Modal.Title>
          </Modal.Header>
          <Modal.Body fieldid={`${realFieldId}-modal-body`}>
            <div
              className={`${uploadFileId} ${props.isDesigner ? 'designer-style' : ''}`}
              id={`${uploadFileId}`}
              ref={fileDom}
            ></div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
  return showType === '2' ? renderNumber() : renderFile()
}
export default Upload
